export {
    WebcalendarTypes
}

namespace WebcalendarTypes {

    export interface RequestData {
        start: Date | string,
        end: Date | string,
        filters: Array<string>,
        subfilters?: Array<string>,
        cid: string,
        mode: string,
        //steps: number,
        keyword?: string,
        resources?: Array<string>,
        viewType: string,
        viewBehaviour: string,
        viewMode: WebCalendar_ViewModes,
        startIndex?: number,
        limit?: number,
        requestID?: string,
        _version: 202401 | 202506 | 202606,
        targetAppointmentID?: string,
        targetAppointmentClass?: string,
        /**
         * optionale Werte die in einer custom GetFilterData Funktion verwendet werden koennen...
         */
        additionalGetFilterDataParameters?: Record<string, string>
    }

    export interface FilterResponse {
        message?: string,
        items: Array<WebCalendarItemData_Default>,
        DataGroupValues: Array<string>
    }


    export interface Holiday extends more.EntityAPIResult {
        description: string,
        note: string,
        is_active: boolean,
        date_start: Date,
        date_end: Date,
        color: more.EntityAPIColor,
        type: string,
        typeCode: string,
        countrName: string,
        countryCode: string,
        stateName: string,
        stateCode: string
    }


    export interface WebCalendar_Pane {
        rootNode: HTMLElement;
        contentNode: HTMLElement;
        buttonNode: HTMLElement;
        mobileButtonNode: HTMLElement;
        name: string;
    }

    export interface CalendarListView_CellClickData {
        node: HTMLElement,
        date: Date,
        evt: Event,
        groupIndex?: 0,
        isAllDay: boolean,
    }
    //export interface SyncfusionCalendar_CellClickData {
    //    cancel: boolean,
    //    node: HTMLElement,
    //    endTime: Date,
    //    startTime: Date,
    //    evt: Event,
    //    groupIndex: number,
    //    isAllDay: boolean,
    //    resource?: SyncfusionCalendarResource
    //}

    export interface CellClickData_Simple {
        node: HTMLElement,
        endTime: Date,
        startTime: Date,
        evt: Event,
        isAllDay: boolean,
        resource?: SyncfusionCalendarResource
    }

    export interface WebCalender_ViewButton {
        name: WebCalendar_ViewButtonNames | string,
        nodeName: string;
        label: string;
        function?: Function;
        custom?: boolean
        iconClass?: string;
        showInViewMenu: boolean,
        showAsButton: boolean
        //translation: string;
    }
    export interface WebCalendar_HtClassdescriptor { ID: string, Classname: string, ref_web_calendar_classdescriptor: WebCalendar_Classdescriptor }
    export interface WebCalendar_Classdescriptor { ID: string, Classname: string }
    export interface WebCalendar_HtColorAttribute { classname: string, ID: string, ref_web_calendar_colorattribute: WebCalendar_ColorAttribute }
    export interface WebCalendar_ColorAttribute { classname: string, ID: string, description: string, entity_classname: string, tmp_class_printname: string }
    //export interface WebCalendar_GroupDescriptor { ID: string, Classname: string, AttributeName: string, txt_group_1: string, txt_group_2: string, txt_group_3: string, txt_group_4: string, txt_group_5: string, txt_group_6: string}

    export interface WebCalendar_FilterAssignment {
        ID: string,
        Classname: string,
        is_active: boolean,
        ref_web_calendar_filter: WebCalendar_Filter;
        EL_subfilters?: Array<WebCalendar_SubfilterAssignment>
    }

    export interface WebCalendar_Filter {
        ID: string,
        description: string,
        coloration: more.EntityAPIColor
    }

    export interface WebCalendar_SubfilterAssignment {
        ID: string,
        order: number,
        is_active: boolean,
        ref_web_calendar_filter: WebCalendar_Filter;
    }


    export type ColorValue = {
        colorId: string,
        classname: string
    };

    export interface WebCalendar_Config {
        ID: string,
        Classname: string,
        ref_web_calendar: {
            ID: string,
            Classname: string,
            description: string,
            is_active: boolean,
            bDataGroupingAvailable: boolean,
            EL_ht_web_calendar_colorattribute_web_calendar: WebCalendar_HtColorAttribute[],
            EL_ht_web_calendar_filter_web_calendar: WebCalendar_FilterAssignment[],
            EL_ht_web_calendar_classdescriptor_web_calendar: WebCalendar_HtClassdescriptor[]
        },
        //ref_web_calendar_groupattr: WebCalendar_GroupDescriptor,
        order: number
        default_view: WebCalendar_ViewModes,
        b_hide_all_options?: boolean,
        b_hide_coloration?: boolean,
        b_allow_view_day: boolean,
        b_allow_view_2weeks: boolean,
        b_allow_view_3days: boolean,
        b_allow_view_month: boolean,
        b_allow_view_year?: boolean,
        b_allow_view_week: boolean,
        b_allow_view_list?: boolean,
        b_allow_view_timelineday?: boolean,
        b_allow_view_timelinedetail?: boolean,
        b_allow_view_timelineoverview?: boolean,
        b_allow_view_timelineyear?: boolean,
        //b_allow_view_timeline: boolean,
        b_show_datagroups: boolean,
        b_show_allday_events_with_full_hours: boolean,
        b_show_empty_groups: boolean,
        b_show_timeindicator: boolean,
        b_show_end_time: boolean,
        b_show_start_time: boolean,
        b_hide_searchpane: boolean
    }

    export const enum WebCalendar_ViewButtonNames {
        "previousButton" = "previousButton",
        "nextButton" = "nextButton",

        "dayButton" = "dayButton",
        "todayButton" = "todayButton",
        "threeDaysButton" = "threeDaysButton",
        "weekButton" = "weekButton",
        "twoWeekButton" = "twoWeekButton",
        "monthButton" = "monthButton",
        "timelineButton" = "timelineButton"
    }

    export const enum WebCalendar_DefaultPanes {
        "datePane" = "datePane",
        "resourcesPane" = "resourcesPane",
        "yearViewPane" = "yearViewPane",
        "filterPane" = "filterPane",
        "colorationPane" = "colorationPane",
        "viewOptionsPane" = "viewOptionsPane",
        "userPane" = "userPane",
        "searchPane" = "searchPane"
    }

    export const enum WebCalendar_ViewTypes {
        "year" = "year",
        "month" = "month",
        "week" = "week",
        "day" = "day",
        "list" = "list"
    }
    export const enum WebCalendar_ViewModes {
        "year" = "year",
        "month" = "month",
        "timelineYear" = "timelineYear",
        "timelineOverview" = "timelineOverview",
        "timelineDetail" = "timelineDetail",
        "timelineDay" = "timelineDay",
        "twoWeeks" = "2weeks",
        "week" = "week",
        "threeDays" = "3days",
        "day" = "day",
        "listView" = "list"
        //"timeline" = "timeline",
        //"calendar" = "calendar"
    }
    export const enum WebCalendar_ViewInstructions {
        "reload" = "reload",
        "today" = "today",
        "previous" = "previous",
        "previousRange" = "previousRange",
        "nextRange" = "nextRange",
        "rangeMin" = "rangeMin",
        "rangeMax" = "rangeMax",
        "next" = "next",
        "stepBackward" = "stepBackward",
        "stepForward" = "stepForward"
    }

    export const enum SyncfusionCalendar_ViewModes {
        "TimelineDay" = "TimelineDay",
        "TimelineWeek" = "TimelineWeek",
        "TimelineMonth" = "TimelineMonth",
        "TimelineYear" = "TimelineYear",
        "Day" = "Day",
        "Week" = "Week",
        "Month" = "Month",
        "Year" = "Year"
    }
    export interface WebCalendarUserPropertiesConfig {
        customFunctionName?: string;
        requestUrl?: string;
        requestParams?: Array<{ name: string, value: any }>;
    }
    export interface WebCalendarMainPropertiesConfig {
        itemDetails?: {
            customFunctionName?: string;
            customItemClickFunction?: Function;
            requestUrl?: string;
            //requestParams?: Array<{ name: string, value: any }>;
        }
        filterData?: {
            //requestUrl?: string;
            customFunctionName?: string;
            requestItemLimit?: number;
            additionArgs?: Record<string, string>
        }
        resourceClickFct?: Function
        gridDoubleClickFct?: Function,
        enableLocalUserSettings?: boolean,
        userProperties?: WebCalendarUserPropertiesConfig,
        dataLoadingLabel?: string,
        defaultDisplaySettings?: WebCalendarDisplaySettings,
        enableQuickSearch?: boolean,
        quickSearchSettings?: {
            selectEntityDlgConfig: any
        },
        checkCreateAppointmentPrivileges?: boolean
    }

    export interface WebCalendarDisplaySettings {
        b_allow_view_day?: boolean,
        b_allow_view_2weeks?: boolean,
        b_allow_view_3days?: boolean,
        b_allow_view_month?: boolean,
        b_allow_view_year?: boolean,
        b_allow_view_week?: boolean,
        b_allow_view_list?: boolean,
        b_allow_view_timeline?: boolean,
        b_hide_all_options?: boolean,
        b_show_datagroups?: boolean,
        b_show_allday_events_with_full_hours?: boolean,
        b_show_empty_groups?: boolean,
        b_show_timeindicator?: boolean,
        b_show_end_time?: boolean,
        b_show_start_time?: boolean,
        hideColumnHead?: boolean,
        autoAdjustToDisplay?: boolean
    }

    export interface WebcalendarItemRequestData {
        CalendarConfigId?: string;
        selectedHtCalendarID?: string;
        ClassName: string;
        EntityId: string;
    }

    export interface WebCalendarRoomType {
        id: string;
        checked: boolean;
    }

    export interface WebCalendarResourceCheckboxes {
        checkbox: HTMLInputElement;
        button: HTMLButtonElement;
        label: HTMLElement;
        resourceData: WebCalendarResourceData<WebCalendarResource_SourceEntity>;
        selected: boolean;
    }
    export interface SyncfusionCalendarResource {
        _originData?: any,
        Count?: number;
        groupId?: string,
        descriptorId: string,
        id: string,
        label: string,
        colorationBG: string;
        colorationTXT: string;
        node: HTMLElement;
        keyProperty: string;
        type: string;
    }
    export interface WebCalendarResource_SourceEntity {
        Classname: string,
        ID: string,
        coloration: more.EntityAPIColor,
        description: string
    }

    export interface WebCalendarResourceData<T> {
        DescriptorId: string;
        allowMultiple: boolean;
        colorField: string;
        colorFieldBG?: string;
        colorFieldTXT?: string;
        coloration: more.EntityAPIColor;
        dataSource: Array<T & WebCalendarResource_SourceEntity>;
        field: string;
        idField: string;
        groupIDField?: string;
        name: string;
        textField: string;
        title: string;
        is_active: boolean;
        resourceType: string;
        itemType: string;
        ResourceGroupsDescriptor: any;
    }

    export interface WebCalendarItemData_Default extends Object {
        id: string;
        Classname: string;
        BaseClasses: Array<string>;
        barview_text: string;
        columnview_head_text: string;
        columnview_body_text: string;
        detailview_text: string;
        Default_BackColor: string;
        Default_TextColor: string;
        bOverrideColoration: boolean;
        coloration: Array<{
            ID: string;
            ComplexAttributeName: string;
            Classname: string;
            BackColor: string;
            TextColor: string;
        }>;
        allDay: boolean;
        editable: boolean;
        resizeEnabled: boolean;
        moveEnabled: boolean;
        startTime: string;
        endTime: string;
        calendar?: string;
        groupValue?: string;
        isHTMLdetailtext?: boolean;
    }

    export interface calendarConfig {
        columnView: {
            firstDayOfWeek: number, // 1 für montag - default
            minHours: number, // The first hour displayed by the main sheet,
            maxHours: number, //The last hour displayed (excluded),
            selectionMode: string, // controls the selection, this property can take the following values: “none” - no selection is possible | “single” - only one item can be selected at most | "multiple” - zero or several items can be selected.
            columnHeaderDatePattern: string,
            //hourSize: number, // The desired size in pixels of one hour,
            //timeSlotDuration: number, // The duration of minutes of the time slot (must be a divisor of 60),
            groupValue?: string,
            groups?: Array<string>
        },
        matrixView: {
            labelRendererHeight: number
        }
    }
}
